import Firebase from 'firebase/app'
import { FirestoreProvider } from 'react-firestore'
import React from 'react'
import ReactGA from 'react-ga'
import { BrowserRouter, Route } from 'react-router-dom'
import { ToastContainer, cssTransition } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import '../styles'
import ErrorBoundary from './misc/ErrorBoundary'
import CloseX from './misc/CloseX'
import Routes from './Routes'

const App = () => (
  <FirestoreProvider firebase={Firebase}>
    <BrowserRouter>
      <ErrorBoundary>
        <Route path="/" component={Analytics}/>
        <Routes />

        {/* https://github.com/fkhadra/react-toastify#toastcontainer */}
        <ToastContainer
          transition={cssTransition({
            enter: 'toastIn',
            exit: 'toastOut',
            duration: 200,
          })}
          hideProgressBar={true}
          closeButton={<CloseX />}
          position="bottom-center"
          draggablePercent={5}
        />
      </ErrorBoundary>
    </BrowserRouter>
  </FirestoreProvider>
)

// Track Google Analytics page view for every route
// https://github.com/react-ga/react-ga/issues/122#issuecomment-319546248
const Analytics = ({location}) => {
  const page = location.pathname + location.search
  ReactGA.set({ page })
  ReactGA.pageview(page)
  return null
}

export default App



// WEBPACK FOOTER //
// ./src/views/App.js